import { BaseException } from 'exceptions/baseException';

export class ServerErrorException extends BaseException {
  static status = 500;

  constructor(message?: string) {
    super(message, ServerErrorException.status);
  }
}
